import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { TgGridModule, TgRackModule } from '@trademe/tangram';
import { ResidentialForSaleSummaryPagePropertyInformationSectionComponent } from './summary-page-property-information-section.component';

@NgModule({
    imports: [CommonModule, TgRackModule, TgGridModule, RouterModule],
    declarations: [
        ResidentialForSaleSummaryPagePropertyInformationSectionComponent
    ],
    exports: [ResidentialForSaleSummaryPagePropertyInformationSectionComponent]
})
export class ResidentialForSaleSummaryPagePropertyInformationSectionModule {}
